module.exports = __webpack_public_path__ + "static/img/zb1-2.d55b6b6.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/zb1-2.png
// module id = 730
// module chunks = 0